import { Map } from 'immutable'

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 */
export const selectUpstreamContext = (state) => state.upstreamContext || Map()

export default { selectUpstreamContext }
